import React from "react";
import { Alert } from "reactstrap";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function VsiAlert ({ color, children, isOpen, toggle }) {
    return (
      <Alert className={"w-50"}
             isOpen={isOpen}
             timeout={200}
             closeAriaLabel={'Close'}
             color={color}
             fade={true}
             toggle={toggle}>
        <i className={`fa-solid fa-${color === "danger" ? "exclamation-triangle" : "check"} me-2`} />
        {children}
      </Alert>
    )
}

export default withErrorBoundary(VsiAlert, GeneralErrorBoundary);